import { useLayoutEffect } from "react";
import { useLocalStorage } from "usehooks-ts";
import { TOKENS } from "./tokens";

export const THEMES = [
  "classic",
  "strawberry matcha",
  "dark",
  "noir",
  "megan",
] as const;

export function useTheme() {
  const [_theme, setTheme] = useLocalStorage<(typeof THEMES)[number]>(
    "theme",
    THEMES[0]
  );
  let theme = _theme;
  // e.g. stale/invalid value
  if (!THEMES.includes(theme)) {
    theme = THEMES[0];
  }
  return [theme, setTheme] as const;
}

export function useSyncTheme() {
  const [theme] = useTheme();
  useLayoutEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);
}

export function validateThemes() {
  let errored = false;
  for (const theme of THEMES) {
    const dummy = document.createElement("div");
    dummy.setAttribute("data-theme", theme);
    dummy.style.position = "absolute";
    dummy.style.width = "0";
    dummy.style.height = "0";
    dummy.style.opacity = "0";
    document.body.appendChild(dummy);
    for (const key of Object.keys(TOKENS)) {
      const cssVariable = getComputedStyle(dummy).getPropertyValue(
        `--color-${key}`
      );
      if (!cssVariable) {
        errored = true;
        console.error(
          `Theme ${theme} is missing the css variable --color-${key}`
        );
      }
    }
    document.body.removeChild(dummy);
  }
  if (errored) {
    throw new Error("Themes invalid");
  }
  console.log("Themes validated");
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useSyncTheme();
  return <>{children}</>;
}
